import { c as _c } from "react/compiler-runtime";
import { cn, CustomError, optimizeImageUrl } from '@core/utils';
import { type ImgHTMLAttributes, useState } from 'react';
interface ImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  src?: string;
  alt: string;
  width: number;
  height: number;
  wrapperClassName?: string;
  unoptimized?: boolean;
}
const IMAGE_PLACEHOLDER = 'https://cdn.welfarehello.com/common/wello-profile.png';
export const Image = t0 => {
  const $ = _c(37);
  let alt;
  let className;
  let height;
  let restProps;
  let src;
  let t1;
  let t2;
  let width;
  let wrapperClassName;
  if ($[0] !== t0) {
    ({
      loading: t1,
      className,
      src,
      alt,
      width,
      height,
      wrapperClassName,
      unoptimized: t2,
      ...restProps
    } = t0);
    $[0] = t0;
    $[1] = alt;
    $[2] = className;
    $[3] = height;
    $[4] = restProps;
    $[5] = src;
    $[6] = t1;
    $[7] = t2;
    $[8] = width;
    $[9] = wrapperClassName;
  } else {
    alt = $[1];
    className = $[2];
    height = $[3];
    restProps = $[4];
    src = $[5];
    t1 = $[6];
    t2 = $[7];
    width = $[8];
    wrapperClassName = $[9];
  }
  const loading = t1 === undefined ? "lazy" : t1;
  const unoptimized = t2 === undefined ? false : t2;
  const [isLoaded, setIsLoaded] = useState(false);
  const imageSrc = typeof src === "string" ? src : IMAGE_PLACEHOLDER;
  if (imageSrc.startsWith("/")) {
    throw new CustomError({
      return_message: `앱 자체 assets은 컴포넌트를 사용할 수 없습니다. - ${imageSrc}`
    });
  }
  let t3;
  if ($[10] !== wrapperClassName) {
    t3 = cn("relative overflow-hidden rounded-xsmall border-1 border-Gray-50", wrapperClassName);
    $[10] = wrapperClassName;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== height || $[13] !== width) {
    t4 = {
      width,
      height
    };
    $[12] = height;
    $[13] = width;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const t5 = !isLoaded;
  let t6;
  if ($[15] !== className || $[16] !== isLoaded || $[17] !== t5) {
    t6 = cn("max-h-[inherit] max-w-[inherit] animate-fade object-cover transition-opacity duration-500", {
      "opacity-100": isLoaded,
      "opacity-0": t5
    }, className);
    $[15] = className;
    $[16] = isLoaded;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== height || $[20] !== imageSrc || $[21] !== unoptimized || $[22] !== width) {
    t7 = unoptimized ? imageSrc : optimizeImageUrl(imageSrc, {
      width,
      height,
      quality: 100,
      format: "original"
    });
    $[19] = height;
    $[20] = imageSrc;
    $[21] = unoptimized;
    $[22] = width;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setIsLoaded(true);
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== alt || $[26] !== height || $[27] !== loading || $[28] !== restProps || $[29] !== t6 || $[30] !== t7 || $[31] !== width) {
    t9 = <picture><img {...restProps} alt={alt} className={t6} height={height} loading={loading} onError={_temp} src={t7} onLoad={t8} width={width} /></picture>;
    $[25] = alt;
    $[26] = height;
    $[27] = loading;
    $[28] = restProps;
    $[29] = t6;
    $[30] = t7;
    $[31] = width;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  let t10;
  if ($[33] !== t3 || $[34] !== t4 || $[35] !== t9) {
    t10 = <div className={t3} style={t4}>{t9}</div>;
    $[33] = t3;
    $[34] = t4;
    $[35] = t9;
    $[36] = t10;
  } else {
    t10 = $[36];
  }
  return t10;
};
function _temp(e) {
  e.currentTarget.src = IMAGE_PLACEHOLDER;
}